import { get } from "svelte/store";

import AuthStore from "../Auth/Store";
import IdentityData from "./IdentityData";

class IdentityHelper {}

// TODO: Remove this HACK. We need this to show heatmap data.
IdentityHelper.current = () => {
	const key = get(AuthStore.userInfo).identity;
	return key in IdentityData ? IdentityData[key] : IdentityData.geollect;
};
export default IdentityHelper;
